import React from "react";
import { RaisedButton, CircularProgress } from "material-ui";
import { Link } from "react-router";
import Helmet from "react-helmet";
import moment from "moment-timezone";
import { colors } from "material-ui/styles";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../stores/PersonStore";
import CreditActions from "../actions/CreditActions";
import CreditStore from "../stores/CreditStore";
import PassStore from "../stores/PassStore";
import PassActions from "../actions/PassActions";

import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

import { formatPrice } from "../util";

class Credits extends React.Component {
  constructor(props) {
    super(props);
    this.getStyles = this.getStyles.bind(this);
  }

  static getStores() {
    return [PersonStore, CreditStore, PassStore];
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool,
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      muiTheme: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  static getPropsFromStores() {
    var props = CreditStore.getState();
    props.isLoggedIn = PersonStore.getState().isLoggedIn;
    props.hasPassesOfBucket = PassStore.hasPassesOfBucket;
    props.hasUpdatedAllPasses = PassStore.getState().hasUpdatedAll;
    return props;
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      CreditActions.fetchCredits();
      PassActions.fetchAll({ firstTimeOnly: true });
    }
  }

  getStyles() {
    const { isLarge, tenant, muiTheme } = this.context,
      { prepareStyles } = muiTheme;

    return {
      loading: {
        padding: 10,
        paddingTop: 30,
        textAlign: "center"
      },
      container: {
        padding: isLarge ? 10 : 25,
        fontSize: "11pt",
        marginTop: isLarge ? 35 : "1em"
      },
      title: {
        textAlign: "center",
        marginTop: 0
      },
      left: isLarge
        ? {
            float: "left",
            width: 300,
            marginRight: 40,
            border: "1px solid #ccc",
            marginBottom: "4em",
            borderRadius: 4,
            marginTop: "-0.25em"
          }
        : {
            marginTop: "-0.5em",
            border: "1px solid #ccc",
            marginBottom: "2em"
          },
      current: {
        padding: "20px 10px",
        textAlign: "center"
      },
      total: {
        fontSize: 90,
        fontWeight: "bold",
        lineHeight: "70px"
      },
      label: {
        fontSize: 20,
        fontStyle: "italic",
        marginTop: 20
      },
      none: {
        fontStyle: "italic",
        textAlign: "center",
        marginTop: "1.5em",
        marginBottom: "1.5em"
      },
      events: {
        padding: "10px",
        borderTop: "1px dashed #ccc"
      },
      eventsHeader: {
        marginTop: "0.5em",
        textAlign: "center"
      },
      eventBody: prepareStyles({
        marginBottom: "0.5em",
        display: "flex",
        alignItems: "center"
      }),
      eventAmount: {
        fontSize: 18,
        fontWeight: "bold",
        marginRight: 10,
        marginLeft: 5
      },
      eventDescription: {},
      eventTime: {
        fontStyle: "italic"
      },
      topContainerNotLoggedIn: {
        maxWidth: 550,
        margin: "0 auto"
      },
      itemContainer: prepareStyles({
        marginTop: "1em",
        border: "1px solid #ccc",
        borderRadius: 4,
        display: isLarge ? "flex" : null
      }),
      item: prepareStyles({
        flex: isLarge ? 1 : null,
        width: isLarge ? "33.3333%" : "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        borderRight: isLarge && "1px solid #ccc",
        borderBottom: !isLarge && "1px solid #ccc",
        padding: 20,
        textAlign: "center"
      }),
      header: {
        textAlign: "center",
        marginTop: 0,
        fontSize: 19,
        marginBottom: "0.75em",
        textTransform: "uppercase"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      {
        isLoggedIn,
        credits,
        events,
        hasUpdatedAllPasses,
        hasPassesOfBucket
      } = this.props;

    if (
      !this.context.appSettings ||
      (isLoggedIn && (this.props.credits === null || !hasUpdatedAllPasses))
    ) {
      return (
        <div style={styles.loading}>
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ margin: 10.5 }}
          />
        </div>
      );
    }

    const passDiscount = this.context.appSettings.credits_discount.percent_off,
      passDiscountApplicable =
        isLoggedIn &&
        this.context.appSettings.credits_discount.pass_buckets.some(b =>
          hasPassesOfBucket(b)
        );

    return (
      <div style={styles.container}>
        {this.props.children}
        {isLoggedIn ? (
          <div style={styles.left}>
            <div style={styles.current}>
              <div style={styles.total}>{credits}</div>
              <div style={styles.label}>Current balance</div>
            </div>
            <div style={styles.events}>
              {events.length ? (
                <div>
                  <h3 style={styles.eventsHeader}>Recent activity</h3>
                  {events
                    .sort((a, b) => b.created_at.localeCompare(a.created_at))
                    .slice(0, 5)
                    .map(e => {
                      return (
                        <div style={styles.eventBody} key={e.id}>
                          <div style={styles.eventAmount}>
                            {e.credits_change > 0 ? "+" : ""}
                            {e.credits_change}
                          </div>
                          <div style={styles.eventDescription}>
                            {e.description}
                            <div style={styles.eventTime}>
                              {moment(e.created_at).fromNow()}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div style={styles.none}>No credit activity, yet.</div>
              )}
            </div>
          </div>
        ) : null}
        <div style={styles.buy}>
          <div style={isLoggedIn ? {} : styles.topContainerNotLoggedIn}>
            <h1 style={styles.title}>{this.context.tenant.credits_header}</h1>
            <InjectedTenantHTML
              content={this.context.tenant.credits_information}
            />
            {!passDiscountApplicable ? (
              <div style={{ marginTop: "0.75em" }}>
                <strong>
                  <Link to={`/${this.context.tenant.passes_url_pathname}/buy`}>
                    BECOME A MEMBER
                  </Link>
                </strong>{" "}
                for the greatest savings of an additional{" "}
                {(passDiscount * 100).toFixed(0)}% discount.
              </div>
            ) : (
              <div
                style={{
                  marginTop: "0.75em",
                  borderRadius: 4,
                  backgroundColor: colors.green500,
                  color: "#fff",
                  padding: 10,
                  display: "inline-block"
                }}
              >
                Your membership entitles you to an automatic additional{" "}
                {(passDiscount * 100).toFixed(0)}% discount.
              </div>
            )}
          </div>
          <div style={styles.itemContainer}>
            {this.context.appSettings.credits_levels.map(
              ({ quantity, price }) => {
                const discountPrice = (1 - passDiscount) * price;

                return (
                  <div key={quantity} style={styles.item}>
                    <h4 style={styles.header}>{quantity} pack</h4>
                    <div
                      style={
                        passDiscountApplicable
                          ? { textDecoration: "line-through" }
                          : {}
                      }
                    >
                      Get {quantity} credits for just {formatPrice(price)}.
                    </div>
                    <div style={{ marginTop: "0.75em" }}>
                      Members save an additional{" "}
                      {(passDiscount * 100).toFixed(0)}%:
                      <br />
                      {quantity} credits for just {formatPrice(discountPrice)}!
                    </div>
                    <div style={{ marginTop: "1em", textAlign: "center" }}>
                      <RaisedButton
                        primary={true}
                        label={`Buy (${formatPrice(
                          passDiscountApplicable ? discountPrice : price,
                          true
                        )})`}
                        onClick={() =>
                          this.context.router.push({
                            pathname: `/credits/topup`,
                            query: { credits: quantity },
                            state: {
                              withDiscount: passDiscountApplicable,
                              fromMainListing: true
                            }
                          })
                        }
                      />
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(Credits);



// WEBPACK FOOTER //
// ./src/app/components/credits.jsx